export default __webpack_public_path__ + "272de34b4497145585aa14089ff86653.pdf";